import { Loader2 } from "lucide-react";

/**
 * Fallback leve para Suspense de rotas lazy.
 * Não duplica Header/Footer/Sidebar — apenas mostra um loader centralizado
 * dentro da área de conteúdo, mantendo o restante do layout estável.
 * Resultado: navegação percebida muito mais rápida e sem "piscar" do shell.
 */
export function RouteFallback() {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Carregando página"
      className="flex items-center justify-center py-24"
    >
      <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
    </div>
  );
}

export default RouteFallback;
